import React from 'react';
import './StatCard.css';

const StatCard = ({ stat }) => {
  const IconComponent = stat.icon;
  
  return (
    <div className="stat-card glass glass-hover card-3d">
      <IconComponent className="stat-icon" />
      <div className="stat-value gradient-text">{stat.value}</div>
      <div className="stat-label">{stat.label}</div>
    </div>
  );
};

export default StatCard;
